/**
 * Re-export the logger from web-essentials
 *
 * Server-side logger - use in server components and API routes
 * Client-side logger hook - use in client components
 */
export { useAppLogging } from '@pursuit-amsterdam/web-essentials/client';
export { logger } from '@pursuit-amsterdam/web-essentials/server';
